export default [
  {
    path: '/zones/new',
    name: 'zones-new',
    component: () => import('@/views/zones/ZoneAdd.vue'),
    meta: {
      resource: 'zones/services',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Zones/New',
      breadcrumb: [
        {
          text: 'Zones-Services',
          to: '/zones-services',
        },
      ],
    },
    allowedCountries: ['LY'],
  },
  {
    path: '/zones/edit',
    name: 'zones-edit',
    component: () => import('@/views/zones/ZoneEdit.vue'),
    meta: {
      resource: 'zones/services',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Zone',
      breadcrumb: [
        {
          text: 'Zones-Services',
          to: '/zones-services',
        },
      ],
      allowedCountries: ['LY'],
    },
  },
  {
    path: '/zones/closed/edit',
    name: 'zones-closed-edit',
    component: () => import('@/views/zones/ClosedZoneEdit.vue'),
    meta: {
      resource: 'zones/services',
      action: 'write',
      requiresAuth: true,
      pageTitle: 'Edit Closed Zone',
      breadcrumb: [
        {
          text: 'Zones-Services',
          to: '/zones-services',
        },
      ],
    },
    allowedCountries: ['LY'],
  },
]
